const baseURL = 'https://mirestaurante2.appboutique.click/';
export default baseURL;